export enum LorenMeteringDataIdsEnum {
    LONGITUDE = 'lng',
    LATITUDE = 'lat',
    VALUE = 'value',
    GPS_DATA_RELIABLE = 'gps_data_reliable',
    NTL_PROBABILITY = 'ntl_probability'
}
